import { AUTH_GLOBALS } from 'util/backendapi/auth-globals';
import { WebsocketEndpoint } from './backendapi/types/Endpoint';

export function createWebsocket(path: WebsocketEndpoint) {
  // Authenticate with backend using oath token
  const accessToken = `Bearer_${AUTH_GLOBALS.dmsAccessToken}`;
  const websocketUrl = `wss://${window.location.host}${path}`;
  return new WebSocket(websocketUrl, accessToken);
}
